/**
 * Pulls the user-facing message out of an `ApiResponse<object>` error body,
 * which is what the backend emits for the blob export endpoints' failure cases
 * (`run.not_found`, `export.not_latest_run`, `export.run_not_succeeded`,
 * `export.per_room_disabled`, `schedule.not_found`, `export.generation_failed`).
 *
 * Falls back to the generic HTTP-status message when the body is empty or
 * shaped differently. A 403 gets a friendly, actionable string rather than the
 * raw backend message, since a mid-session role change is the usual cause.
 *
 * Shared by every blob-download call site (`downloadExportBundle` in
 * `runs-api.ts` and `downloadSolverInputs` in `solver-input-export.ts`) so the
 * error-as-blob normalization lives in exactly one place.
 */
export function extractExportErrorMessage(
  data: unknown,
  status: number,
): string {
  if (status === 403) {
    return "You don't have permission to export this schedule.";
  }
  if (data && typeof data === "object" && "message" in data) {
    const message = (data as { message?: unknown }).message;
    if (typeof message === "string" && message.trim().length > 0) {
      return message;
    }
  }
  return `Download failed (HTTP ${status})`;
}
